import React, { Fragment } from "react";
import { FormattedMessage, defineMessages, FormattedNumber } from "react-intl";
import { Link } from "react-router";
import Panel from "../Panel/Panel";
import styles from "./BalanceSummary.module.less";
import moment from "moment";
import orderBy from "lodash/orderBy";
import { getRoutePaymentStatus } from "../../../../../domain/payment/paymentUtils";
import ScheduledPayment from "./ScheduledPayment/ScheduledPayment";
import Table from "assets/scripts/components/presentational/Table/Table";
import MDPatientSheet from "assets/scripts/components/common/MDPatientSheet/MDPatientSheet";
const messages = defineMessages({
    header: {
        id: "account.balanceSummary.header",
        defaultMessage: "Payments"
    },
    paymentAmount: {
        id: "account.balanceSummary.scheduledPayment.paymentAmount",
        defaultMessage: "Payment Amount"
    },
    paymentDate: {
        id: "account.balanceSummary.scheduledPayment.paymentDate",
        defaultMessage: "Payment Date"
    },
    from: {
        id: "account.balanceSummary.scheduledPayment.from",
        defaultMessage: "From"
    },
    newTableDate: {
        id: "account.balanceSummary.table.date",
        defaultMessage: "Date"
    },
    newTableAmount: {
        id: "account.balanceSummary.table.amount",
        defaultMessage: "Amount"
    },
    status: {
        id: "account.balanceSummary.table.status",
        defaultMessage: "Status"
    }
});
function getPayments(group) {
    const payments = [];
    const ids = {};
    for (const account of group.accounts) {
        for (const payment of account.payments) {
            if (payment.id in ids) {
                continue;
            }
            ids[payment.id] = true;
            payments.push(payment);
        }
    }
    return orderBy(payments, ({ dateUtc }) => moment(dateUtc).valueOf());
}
const BalanceSummary = ({ acct }) => {
    const payments = getPayments(acct);
    const scheduledPayment = payments.find(it => it.status === "Scheduled");
    const { paymentAllowed, message } = getRoutePaymentStatus(acct);
    const columns = [];
    columns.push({
        header: messages.newTableDate,
        value: it => moment(it.dateUtc).format("M/D/YYYY"),
        centerFirstColumn: true
    }, {
        header: messages.newTableAmount,
        value: it => <FormattedNumber value={it.amount} style="currency" currency="USD"/>
    }, {
        header: messages.status,
        value: it => {
            switch (it.status) {
                case "Accepted":
                    return "Processed";
                case "Rejected":
                case "Scheduled":
                case "Canceled":
                    return status;
                case "Pending":
                default:
                    return "";
            }
        }
    });
    const showPaymentTable = payments.length > 0; // && (payments.length > 1 || payments[0] !== scheduledPayment);
    const payButtonContent = (<FormattedMessage id="account.balanceSummary.payNow.label" defaultMessage="Make a Payment"/>);
    return (<Panel heading={messages.header}>
			<div className={styles.row}>
				<div>
					<div className="vr vr_x4">
						{paymentAllowed && (<Link to={`/secured/payNow/${acct.primary.id}`} className="btn mix-btn_fixedWidth btn-progressive" data-test="payNowButton">
								{payButtonContent}
							</Link>)}
						{!paymentAllowed && (<Fragment>
								<button type="button" className="btn mix-btn_fixedWidth btn_isDisabled btn-progressive" disabled data-test="payNowButton">
									{payButtonContent}
								</button>
								{message != null && (<div className="text mix-text_small error" style={{ marginTop: 5 }}>
										<p>
											{message}
										</p>
									</div>)}
							</Fragment>)}
					</div>

					<div>
						<div className="text mix-text_small">
							<p>
								<FormattedMessage id="account.balanceSummary.mail" defaultMessage="Checks can be mailed to: {name}" values={{
        name: (<span className={styles.mailName}>
												<FormattedMessage id="account.balanceSummary.mail.name" defaultMessage="DCM Services LLC"/>
											</span>)
    }}/>
								<br />
								<FormattedMessage id="account.balanceSummary.mail.address" defaultMessage="1550 American Blvd E., Suite 200, Bloomington, MN 55425"/>
							</p>
						</div>
					</div>
				</div>
				{scheduledPayment && (<div>
						<ScheduledPayment payment={scheduledPayment}/>
					</div>)}
			</div>
			{showPaymentTable && (<div className={styles.table}>
					<div className="text mix-text_small vr vr_x1">
						<FormattedMessage tagName="p" id="account.balanceSummary.table.summary" defaultMessage={"The payments listed below are payments that were made using the ServiceLink "
        + "application. Any payments made outside of the ServiceLink application will "
        + "not be displayed here."}/>
					</div>
					<Table items={payments} columns={columns} srLabel="Payment" srLabelPlural="Payments" getKey={it => it.id}/>
				</div>)}
			{acct.primary.hasMDPatientInfoSheet && (<MDPatientSheet clientId={acct.primary.clientId} clientName={acct.primary.clientName} hasSpanish={acct.primary.hasMDPatientInfoSheetES} padTop/>)}
		</Panel>);
};
export default BalanceSummary;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Account/BalanceSummary/BalanceSummary.tsx